import { useActiveScene } from './useActiveScene';
import { useProject } from './useProject';
import { useTrackHeight } from './useTrackHeight';

export enum NewAudioLayerType {
  ActiveSceneLayer = 'new-active-scene-layer',
  ProjectLayer = 'new-project-layer'
}

export function useLayoutTopToAudioLayer() {
  const { trackHeight } = useTrackHeight();
  const project = useProject();
  const activeScene = useActiveScene();

  const layoutTopToAudioLayer = (layoutTop: number) => {
    if (!project || !activeScene) return;

    const sceneAudioLayers = activeScene.audioLayerIds ?? [];
    const projectAudioLayers = project.projectAudioLayerIds ?? [];

    const layerMap: { [top: number]: string } = {
      0: NewAudioLayerType.ActiveSceneLayer,
      [(sceneAudioLayers.length + 1) * trackHeight]: NewAudioLayerType.ProjectLayer
    };

    sceneAudioLayers.toReversed().forEach((layerId, index) => {
      layerMap[(index + 1) * trackHeight] = layerId;
    });

    projectAudioLayers.toReversed().forEach((layerId, index) => {
      layerMap[(sceneAudioLayers.length + 2 + index) * trackHeight] = layerId;
    });

    return layerMap[layoutTop] ?? NewAudioLayerType.ActiveSceneLayer;
  };

  return layoutTopToAudioLayer;
}
